var PreChannelKey = /** @class */ (function () {
    function PreChannelKey(dataSourceCode, historyDataName) {
        this.dataSourceCode = dataSourceCode;
        this.historyDataName = historyDataName;
    }
    return PreChannelKey;
}());
export { PreChannelKey };
